<template>
  <div style="padding:20px;">
    <h1>运费模板设置</h1>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="margin-top:30px">
      <el-form-item label="模板名称：" prop="name">
        <el-input v-model="form.name" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="发货时间：" prop="deliveryTime">
        <el-select v-model="form.deliveryTime" placeholder="请选择">
          <el-option  label="1天内" value="1"></el-option>
          <el-option  label="2天内" value="2"></el-option>
          <el-option  label="3天内" value="3"></el-option>
          <el-option  label="5天内" value="5"></el-option>
          <el-option  label="7天内" value="7"></el-option>
          <el-option  label="8天内" value="8"></el-option>
          <el-option  label="10天内" value="10"></el-option>
          <el-option  label="12天内" value="12"></el-option>
          <el-option  label="15天内" value="15"></el-option>
          <el-option  label="17天内" value="17"></el-option>
          <el-option  label="20天内" value="20"></el-option>
          <el-option  label="25天内" value="25"></el-option>
          <el-option  label="30天内" value="30"></el-option>
          <el-option  label="35天内" value="35"></el-option>
          <el-option  label="45天内" value="45"></el-option>
        </el-select>
        <span class="time-tip">如实设定宝贝的发货时间、不仅可避免发货咨询和纠纷，还能促进成交！</span>
      </el-form-item>
      <el-form-item label="是否包邮：" required>
        <el-radio-group v-model="form.isFreeShipping">
          <el-radio :label="false">自定义运费</el-radio>
          <el-radio :label="true">卖家承担运费</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="!form.isFreeShipping" required>
        <template slot="label">
          运输方式：
          <span class="tip">除指定地区外，其余地区的运费采用“默认运费”</span>
        </template>
        <div class="table">
          <el-row class="row header">
            默认运费
            <el-input size="mini" class="input" v-model.number="form.defaultFreight.firstCount" type="number"></el-input>件内
            <el-input size="mini" class="input" v-model.number="form.defaultFreight.firstPrice" type="number"></el-input>美元，每增加
            <el-input size="mini" class="input" v-model.number="form.defaultFreight.addCount" type="number"></el-input>件，增加运费
            <el-input size="mini" class="input" v-model.number="form.defaultFreight.addPrice" type="number"></el-input>美元
          </el-row>
          <el-row class="row section" :gutter="10" v-show="form.freights.length > 0">
            <el-col :span="4">运送到</el-col>
            <el-col :span="4" :offset="2">首件数（件）</el-col>
            <el-col :span="4">首费（美元）</el-col>
            <el-col :span="4">续件数（件）</el-col>
            <el-col :span="4">续费（美元）</el-col>
            <el-col :span="2">操作</el-col>
          </el-row>
          <el-row class="row cell" :gutter="10" v-for="freight in form.freights" :key="freight.key">
            <el-col :span="4">{{freight.cityName || '未添加地区'}}</el-col>
            <el-col :span="2">
              <a @click="localChangeAction(freight.key)">编辑</a>
            </el-col>
            <el-col :span="4">
              <el-input size="mini" class="input" v-model.number="freight.firstCount" type="number"></el-input>
            </el-col>
            <el-col :span="4">
              <el-input size="mini" class="input" v-model.number="freight.firstPrice" type="number"></el-input>
            </el-col>
            <el-col :span="4">
              <el-input size="mini" class="input" v-model.number="freight.addCount" type="number"></el-input>
            </el-col>
            <el-col :span="4">
              <el-input size="mini" class="input" v-model.number="freight.addPrice" type="number"></el-input>
            </el-col>
            <el-col :span="2">
              <a @click="localDeleteAction(freight.key)">删除</a>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <a @click="localEditAction" class="local-add" v-show="!form.isFreeShipping">为置顶地区城市设置运费</a>
    </el-form>
    <el-button type="primary" round class="submit-btn" @click="submitAction">保存并返回</el-button>
  </div>
</template>

<script>
export default {
  name: 'CarriageTemplate',
  props: {
    id: {
      type: Number,
      default: undefined
    },
    stop: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        name: null,
        deliveryTime: null,
        isFreeShipping: false,
        defaultFreight: {
          firstCount: null,
          firstPrice: null,
          addCount: null,
          addPrice: null
        },
        freights: []
      },
      rules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        deliveryTime: [
          { required: true, message: '请选择发货时间', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.loadTemplate()
  },
  methods: {
    refreshUI () {
      if (this.id) {
        this.loadTemplate()
      } else {
        this.form = {
          name: null,
          deliveryTime: null,
          isFreeShipping: false,
          defaultFreight: {
            firstCount: null,
            firstPrice: null,
            addCount: null,
            addPrice: null
          },
          freights: []
        }
      }
    },
    loadTemplate () {
      if (!this.id) { return }
      
      this.$api.customer.loadCustomerFreightModelDetails({
        CFMId: this.id
      }).then(res => {
        let data = res.data
        let isFree = data.IsFree > 0
        this.form.name = data.FModelName
        this.form.deliveryTime = data.DeliverTime
        this.form.isFreeShipping = isFree
        if (!isFree) {
          this.form.defaultFreight.firstCount = data.DefultFreightModelInfo.ItemCount
          this.form.defaultFreight.firstPrice = data.DefultFreightModelInfo.ItemPrice
          this.form.defaultFreight.addCount = data.DefultFreightModelInfo.AddNumber
          this.form.defaultFreight.addPrice = data.DefultFreightModelInfo.AddPrice
          this.form.defaultFreight.id = data.DefultFreightModelInfo.CFInfoId
          if (data.ListFreightModelInfo) {
            this.form.freights = data.ListFreightModelInfo.map((v, i) => ({
              key: i,
              firstCount: v.ItemCount,
              firstPrice: v.ItemPrice,
              addCount: v.AddNumber,
              addPrice: v.AddPrice,
              countryCode: v.CountryCode,
              cityName: v.CityName,
              id: v.CFInfoId
            }))
          }
        }
        
      }).catch(error => {
        
        this.$message.error(error)
      })
    },
    localEditAction () {
      this.form.freights.push({
        key: Date.now(),
        firstCount: null,
        firstPrice: null,
        addCount: null,
        addPrice: null,
        countryCode: null,
        cityName: null
      })
    },
    localDeleteAction (key) {
      let index = this.form.freights.findIndex(n => n.key === key)
      if (index >= 0) {
        this.form.freights.splice(index, 1)
      }
    },
    localChangeAction (key) {
      let freight = this.form.freights.find(n => n.key === key)
      this.$countrySelection({
        selectedCountryID: freight.countryCode,
        onSelected: country => {
          freight.countryCode = country.CountryId
          freight.cityName = country.CountryChineseSimplifiedName
        }
      })
    },
    submit () {
      this.validateParam().then(res => {
        return this.$api.customer.editCustomerFreightModel(res)
      }).then(res => {
        this.$emit('save')
        if (this.stop) return
        this.$router.go(-1)
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    submitAction () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          return false
        }
      })
    },
    validateParam () {
      return new Promise((resolve, reject) => {
        let param = {
          FModelName: this.form.name,
          DeliverTime: this.form.deliveryTime,
          IsFree: this.form.isFreeShipping ? 1 : 0
        }
        if (this.id) {
          param.CFMId = this.id
        }
        if (this.form.isFreeShipping) {
          resolve(param)
        } else {
          let defaultFreightValidate = this.validateFreight(this.form.defaultFreight, true)
          if (!defaultFreightValidate.valid) {
            reject(new Error(defaultFreightValidate.msg))
          } else {
            param.DefultFreightModelInfo = defaultFreightValidate.data
            if (this.form.freights.length > 0) {
              let valid = true
              let msg
              let freightsParam = []
              for (const freight of this.form.freights) {
                const res = this.validateFreight(freight)
                if (!res.valid) {
                  valid = false
                  msg = res.msg
                  break
                }
                freightsParam.push(res.data)
              }
              if (valid) {
                param.ListFreightModelInfo = freightsParam
                resolve(param)
              } else {
                reject(new Error(msg))
              }
            } else {
              resolve(param)
            }
          }
        }
      })
    },
    validateFreight (freight, isDefault = false) {
      let msg
      let valid = false
      if (!Number.isInteger(freight.firstCount) || freight.firstCount <= 0) {
        msg = '请正确填写运输方式首件数'
        return { valid, msg }
      }
      if (freight.firstPrice <= 0) {
        msg = '请正确填写运输方式首件费'
        return { valid, msg }
      }
      if (!Number.isInteger(freight.addCount) || freight.addCount <= 0) {
        msg = '请正确填写运输方式续件数'
        return { valid, msg }
      }
      if (freight.addPrice <= 0) {
        msg = '请正确填写运输方式续件费'
        return { valid, msg }
      }
      if (isDefault) {
        valid = true
        msg = '验证成功'
        let data = {
          ItemCount: freight.firstCount,
          ItemPrice: freight.firstPrice,
          AddNumber: freight.addCount,
          AddPrice: freight.addPrice
        }
        if (freight.id) {
          data.CFInfoId = freight.id
        }
        return { valid, msg, data }
      } else {
        if (freight.countryCode && freight.cityName) {
          valid = true
          msg = '验证成功'
          let data = {
            ItemCount: freight.firstCount,
            ItemPrice: freight.firstPrice,
            AddNumber: freight.addCount,
            AddPrice: freight.addPrice,
            CountryCode: freight.countryCode,
            CityName: freight.cityName
          }
          if (freight.id) {
            data.CFInfoId = freight.id
          }
          return { valid, msg, data }
        } else {
          msg = '请选择运输方式地区'
          return { valid, msg }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
  margin: 0;
}
.time-tip {
  font-size: 12px;
  color: #999;
  margin-left: 10px;
}
.tip {
  position: absolute;
  font-size: 12px;
  padding-left: 12px;
}
.a-action {
  cursor: pointer;
  color: #25b9ff;
}
.submit-btn {
  margin-top: 100px;
  width: 300px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.table {
  // border-radius: 10px;
  border-radius: 12px 12px 6px 6px;
  overflow: hidden;
  margin-top: 40px;
  font-size: 14px;

  .row {
    padding-left: 26px;
    padding-right: 26px;

    .col {
      height: 100%;
    }
  }
  .header {
    background-color: #d9ebe8;
    height: 46px;
    align-items: center;
    justify-content: space-between;
    line-height: 46px;

    .input {
      width: 60px;

      ::v-deep input {
        text-align: center;
        padding: 0 5px;
      }
    }
  }
  .section {
    background-color: #f3f3f3;
    font-weight: bold;
    height: 32px;
    line-height: 32px;
    text-align: center;
  }

  .cell {
    background-color: #f9f9f9;
    height: 40px;
    line-height: 40px;
    text-align: center;

    a {
      @extend .a-action;
    }

    .el-col {
      height: 100%;
    }

    .input {
      padding-left: 15px;
      padding-right: 15px;
      ::v-deep input {
        text-align: center;
        padding: 0 5px;
      }
    }
  }
}
.local-add {
  @extend .a-action;
  padding-left: 126px;
  font-size: 14px;
}
</style>
